module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/hard-drive-5276ff6194e4a1aa7259280f7409dc49.svg";